"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
require("./Spinner.scss");
var Spinner = function () { return react_1.default.createElement("div", { className: "spinner__spinner" }); };
exports.SpinnerInverted = function () { return (react_1.default.createElement("div", { className: "spinner__spinner spinner__spinner--inverted" })); };
exports.CenteredSpinner = function (_a) {
    var _b = _a.inverted, inverted = _b === void 0 ? false : _b, message = _a.message;
    return (react_1.default.createElement("div", { className: "flex justify-center flex-col items-center h-full" },
        react_1.default.createElement("div", { className: "text-center" }, inverted ? react_1.default.createElement(exports.SpinnerInverted, null) : react_1.default.createElement(Spinner, null)),
        message && react_1.default.createElement("div", { className: "font-semibold text-blue text-center mt-4" }, message)));
};
exports.default = Spinner;
//# sourceMappingURL=index.js.map